import Rollbar from 'rollbar';
const env = process.env.NODE_ENV ? process.env.NODE_ENV : 'production';

const baseConfig = {
  captureUncaught: true,
  captureUnhandledRejections: true,
  // Must match the `version` passed to RollbarSourcemapPlugin so Rollbar can
  // look up the correct source map for each error.
  code_version: process.env.NEXT_BUILD_ID,

  enabled: env !== 'development',

  environment: process.env.NODE_ENV,
};

export const clientConfig = {
  accessToken: process.env.NEXT_PUBLIC_POST_CLIENT_ITEM_TOKEN,
  ...baseConfig,
};

export const serverInstance = new Rollbar({
  accessToken: process.env.POST_SERVER_ITEM_TOKEN,
  ...baseConfig,
});
